import { render, staticRenderFns } from "./MaterialComparisonTable.vue?vue&type=template&id=6b5fc797&scoped=true&"
import script from "./MaterialComparisonTable.vue?vue&type=script&lang=js&"
export * from "./MaterialComparisonTable.vue?vue&type=script&lang=js&"
import style0 from "./MaterialComparisonTable.vue?vue&type=style&index=0&id=6b5fc797&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5fc797",
  null
  
)

export default component.exports